var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VChart,{staticClass:"chart",attrs:{"type":"bar","options":_setup.state.options,"data":_setup.state.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }